import React from "react";
import ConstrucaoImg from "../img/em-construcao.gif";
import styles from "../styles/petshop.module.css";

const Cursos: React.FC = () => {
  return (
    <div className={styles.imagem}>
      <img id={styles.construcao} src={ConstrucaoImg} alt="Construção" />
      <h1 id={styles.texto}>Em construção...</h1>
    </div>
  );
};

export default Cursos;
